export default function getCustomerType(type) {
    if (type === "BUSINESS") return "Gewerbe";
    else if (type === "PRIVATE") return "Privat";
    else return "";
}
